import { render, staticRenderFns } from "./MyCoins.vue?vue&type=template&id=6a550d7d&scoped=true"
import script from "./MyCoins.vue?vue&type=script&lang=js"
export * from "./MyCoins.vue?vue&type=script&lang=js"
import style0 from "./MyCoins.vue?vue&type=style&index=0&id=6a550d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a550d7d",
  null
  
)

export default component.exports